/**
 * Сколько ответ считается свежим по умолчанию.
 *
 * Тридцать секунд — компромисс: переход между экранами не бьёт по сети
 * повторно, а отсечка приёма Прогнозов (её двигает сервер) не успевает
 * устареть заметно для игрока.
 */
export const STALE_AFTER_MS = 30_000;

/** Данные загружены и ещё не протухли. `null` — не грузили ни разу. */
export function isFresh(
  loadedAt: number | null,
  ttlMs: number = STALE_AFTER_MS,
): boolean {
  return loadedAt !== null && Date.now() - loadedAt < ttlMs;
}
